function e(t) {
  const o = t.replace(/:\d+$/, "");
  return /^systeme\.(?:io|club|local)$/i.test(o);
}
export {
  e as isSioHost
};
